import Strings from "../../../../../resources/Strings";
import { DEFAULT_DIALING_CODE } from "../../../../../constants/Constants";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SearchUserStep from "../Steps/SearchUserStep";
import classes from "../WizardForm.module.css";
import TicketStep from "../Steps/TicketStep";
import * as validationsActions from "../../../../../services/ActionsService/ValidationsActionsService";
import * as carActionsService from "../../../../../services/ActionsService/CarActionsService";
import store from "../../../../../redux/Store";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { showErrorMessage, showMissingFieldsValueErrorMessage, showValidateParkingSuccessMessage } from "../../../../../utils/MessagesUtils";
import { VERIFICATION_TYPES } from "../../../../../enums/Enums";
import { getSiteByScopeId } from "../../../../../utils/UsersUtils";
import { AssignDiscountTokenEntity } from "../../../../../entities/ServicesEntities/UserEntities/AssignDiscountTokenEntity";
import { handleValidateParking } from "../../../../../utils/MenuUtils";
import { getValidateParkTimeFormat, phoneNumberToSend } from "../../../../../utils/CommonUtils";

const ValidationsForm = () => {
  let isFirstTimeLoading = useSelector((state) => state.common.isFirstTimeLoading);
  let gmtUser = useSelector((state) => state.user.gmtUser);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const sites = useSelector((state) => state.user?.sites);
  let selectedSite = getSiteByScopeId(sites, selectedScope?.id);

  const [formData, setFormData] = useState({
    email: "",
    dialingCode: DEFAULT_DIALING_CODE,
    phoneNumber: "",
    validationType: "",
    isStepSubmitted: false
  });

  const [foundedTicketData, setFoundedTicketData] = useState(null);
  const [validationsList, setValidationsList] = useState([]);

  const [stateData, setStateData] = useState({
    isCurrentStepValid: false
  });

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  useEffect(() => {
    validationsActions.getChargeAccountToDiscountsByUserId(gmtUser?.utronUser?.id, isFirstTimeLoading, !isFirstTimeLoading)
    .then(response => {
      if (response.data.isSuccess) {
        setValidationsList(response.data.entity.map(catd => catd.discount));
        handleChange({["validationType"] : response.data.entity.map(catd => catd.discount)[0].id});
      }
      else {
        //error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    }).catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      showErrorMessage(error);
    });

    store.dispatch(commonActions.setIsFirstTimeLoading(false));
  }, []);

  const searchUser = () => {
    let isAnyFieldHasValue = formData?.email !== "" || formData?.phoneNumber !== "";
    setFormData({ ...formData, ["isStepSubmitted"]: true });

    if (!isAnyFieldHasValue) {
      showMissingFieldsValueErrorMessage();
      return;
    }

    if (stateData.isCurrentStepValid) {
      let {email, dialingCode, phoneNumber} = formData;
      let contactType;
      let contactInfo;

      // check contact type
      if (email !== "" && phoneNumber === "") {
        contactType = VERIFICATION_TYPES.MAIL;
        contactInfo = email;
      }
      if (email === "" && phoneNumber !== "") {
        contactType = VERIFICATION_TYPES.MOBILE;
        contactInfo = dialingCode + phoneNumberToSend(dialingCode, phoneNumber);
      }

      validationsActions.searchUserForValidation(contactInfo, contactType, selectedSite?.id, true, false)
      .then(response => {
        if (response.data.isSuccess) {
          let tokenValue = response.data.entity.value;

          carActionsService.getCarStatus(tokenValue, selectedSite?.id)
          .then(response => {
            if (response.data.isSuccess) {
              setFoundedTicketData({
                ["contactInfo"] :  email === "" && phoneNumber !== "" ? `+${contactInfo}` : contactInfo,
                ["entranceTime"] : getValidateParkTimeFormat(response.data?.entity?.ParkTime), 
                ["tokenValue"] : response.data.entity.CarUserToken
              });
            }
            else {
              // reset
              setFoundedTicketData(null);
              resetFormData();

              //error
              showErrorMessage(response.data?.error);
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            }
          })
          .catch(error => {
            // reset
            setFoundedTicketData(null);
            resetFormData();

            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            showErrorMessage(error);
          });
          
        }
        else {
          // reset
          setFoundedTicketData(null);
          resetFormData();

          //error
          showErrorMessage(response.data?.error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }

      }).catch(error => {
        // reset
        setFoundedTicketData(null);
        resetFormData();

        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        showErrorMessage(error);
      });
    }   
  };

  const openValidateParkingModal = () => {
    handleValidateParking(() => validate());
  };

  // assignValidation
  const validate = () => {
    let tokenValue = foundedTicketData?.tokenValue;
    let discountId = formData?.validationType;
    validationsActions.assignDiscountForToken(new AssignDiscountTokenEntity(tokenValue, discountId))
    .then(response => {
      if (response.data.isSuccess) {
        setFoundedTicketData(null);
        resetFormData();
        showValidateParkingSuccessMessage();
      }
      else {
        //error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      showErrorMessage(error);
    });
  };

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const resetFormData = () => {
    setFormData({
      email: "",
      dialingCode: formData?.dialingCode, 
      phoneNumber: "",
      validationType: validationsList[0]?.id,
      isStepSubmitted: false
    });
  };

  const instructions = Object.entries(Strings.VALIDATION_INSTRUCTIONS).map((entry, index) => {
    // take last char and check if its a number
    // /*entry[0]?.startsWith("S")*/ 
    if (!isNaN(parseInt(entry[0]?.slice(entry[0]?.length - 1, entry[0]?.length)))) {
        return <p key={index}><span className={classes.subTitle}>{Strings.STEP} {index}:</span> {entry[1]}</p>
    }
    if (index === Object.keys(Strings.VALIDATION_INSTRUCTIONS).length - 1) {
        return <p key={index}>{entry[1]}</p>
    }
  });

  return (
    <>
        <div className={classes.validationMargin}>
            <div className={classes.wrapWhiteSpace}><span className={classes.subTitle}>{Strings.VALIDATION_INSTRUCTIONS.TITLE}</span>
                {instructions}
                {/* <p><span className={classes.subTitle}>Step 1: </span> {Strings.VALIDATION_INSTRUCTIONS.STEP1}</p>
                <p><span className={classes.subTitle}>Step 2: </span> {Strings.VALIDATION_INSTRUCTIONS.STEP2}</p>
                <p><span className={classes.subTitle}>Step 3: </span> {Strings.VALIDATION_INSTRUCTIONS.STEP3}</p> */}
                {/* <p>{Strings.VALIDATION_INSTRUCTIONS.INFO}</p> */}
            </div>

            <div className={classes.validationFormContainer}>
                <form name="ValidationsForm">
                    <div className={classes.searchUserContainer}>
                        <SearchUserStep 
                          searchUser={searchUser} 
                          handleChange={handleChange} 
                          handleCurrentStepValidity={handleCurrentStepValidity}
                          {...formData}
                        />
                    </div>
                    {foundedTicketData !== null &&
                      <TicketStep 
                      foundedTicketData={foundedTicketData}
                      validationsList={validationsList}
                      validate={openValidateParkingModal}
                      handleChange={handleChange} 
                      handleCurrentStepValidity={handleCurrentStepValidity}
                      {...formData}
                    />}
                </form>
            </div>
        </div>     
    </>
  )
}

export default ValidationsForm;